import React from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { canOpenIntroduction } from "./signupPurpose";
import { contextualGuides, canOpenQuickStart } from "./contextualHelp";

export function ContextualHelpDialog({
  user,
  pathname,
  onClose,
  onQuickStart,
  onGettingStarted,
}) {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const guides = contextualGuides(pathname, user);
  return (
    <Dialog
      open
      onClose={onClose}
      fullWidth
      maxWidth="sm"
      fullScreen={fullScreen}
      aria-labelledby="contextual-help-title"
      sx={{ zIndex: (theme) => theme.zIndex.modal + 1 }}
    >
      <DialogTitle id="contextual-help-title">Help and tutorials</DialogTitle>
      <DialogContent dividers>
        <Typography sx={{ mb: 2 }}>
          {guides.length
            ? "Useful guides for this page."
            : "Explore the help library at your own pace."}{" "}
          Guides open in a new tab so you can keep your work here.
        </Typography>
        <Stack gap={3}>
          {guides.map((guide) => (
            <Stack key={guide.id} gap={1} alignItems="flex-start">
              <Typography component="h2" variant="h6">
                {guide.title}
              </Typography>
              <Typography variant="body2">{guide.summary}</Typography>
              <Button
                component="a"
                href={guide.href}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={`Read ${guide.title} (opens in a new tab)`}
              >
                {guide.stepTitle ? `Go to: ${guide.stepTitle}` : "Read guide"}
              </Button>
            </Stack>
          ))}
          <Button
            component="a"
            href="/help"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Browse all guides (opens in a new tab)"
            variant="outlined"
          >
            Browse all guides
          </Button>
          {canOpenIntroduction(user) && (
            <Button variant="outlined" onClick={onGettingStarted}>
              Getting started
            </Button>
          )}
          {canOpenQuickStart(user) && (
            <Stack gap={1} alignItems="flex-start">
              <Typography component="h2" variant="h6">
                Try your own answer
              </Typography>
              <Typography variant="body2">
                Quick Start helps you create a real assignment and submit an
                answer in your direct teacher account.
              </Typography>
              <Button variant="contained" onClick={onQuickStart}>
                Open Quick Start
              </Button>
            </Stack>
          )}
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Close help</Button>
      </DialogActions>
    </Dialog>
  );
}
